import type React from 'react'

import type { SubscriptionStat } from '@/store/reducers/subscription'
import { StatsCard } from './components'
import css from './styles.module.css'

interface Props {
  stats: SubscriptionStat[]
}

export const SubscriptionStats: React.FC<Props> = ({ stats }) => {
  return (
    <div className={css.subscription_stats}>
      {stats.map((stat) => (
        <StatsCard item={stat} key={stat.label} />
      ))}
    </div>
  )
}
